type LoaderProps = { src: string; width: number; quality?: number };

const ABS_HTTP = /^https?:\/\//i;

function appendSizingParams(path: string, width: number, quality: number): string {
  const url = new URL(path, 'http://n');
  url.searchParams.set('w', String(width));
  url.searchParams.set('q', String(quality));

  return `${url.pathname}${url.search}`;
}

export default function imageProxyLoader({ src, width, quality }: LoaderProps) {
  const q = quality ?? 75;

  // Inline sources cannot accept query params.
  if (src.startsWith('data:') || src.startsWith('blob:')) {
    return src;
  }

  // Local paths and already-proxied URLs — append sizing params for Next.js srcSet.
  if (src.startsWith('/api/image-proxy') || src.startsWith('/')) {
    return appendSizingParams(src, width, q);
  }

  // External URLs — route through the image proxy with width.
  if (ABS_HTTP.test(src)) {
    if (process.env.NEXT_PUBLIC_BASE_URL) {
      const url = new URL('/api/image-proxy', process.env.NEXT_PUBLIC_BASE_URL);
      url.searchParams.set('src', src);
      url.searchParams.set('w', String(width));
      url.searchParams.set('q', String(q));
      return url.toString();
    }

    const params = new URLSearchParams();
    params.set('src', src);
    params.set('w', String(width));
    params.set('q', String(q));
    return `/api/image-proxy?${params.toString()}`;
  }

  return appendSizingParams(src.startsWith('/') ? src : `/${src}`, width, q);
}
